import { latestUpdates } from '@/mocks/motionComics';

export default function LatestUpdates() {
  return (
    <section id="latest" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-widest text-primary-400">LATEST</span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-50 md:text-4xl">追更动态 · 一集不落</h2>
            <p className="mt-3 max-w-xl text-sm leading-7 text-foreground-300">
              最新话数实时同步，配音版及时上架。点开即播、流畅加载，再也不用担心错过下一集。
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
            <i className="ri-time-fill text-secondary-600" aria-hidden="true"></i>实时更新
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {latestUpdates.map((u, i) => (
            <a
              key={`${u.title}-${i}`}
              href="#featured"
              className="card-lift flex items-center gap-3 rounded-lg border border-background-300/50 bg-background-100 p-3 md:p-3.5"
            >
              <div className="relative h-16 w-24 shrink-0 overflow-hidden rounded-md md:h-[72px] md:w-[104px]">
                <img
                  src={u.cover}
                  alt={`${u.title} ${u.episode} 动态漫画更新封面`}
                  title={`${u.title} 最新话`}
                  className="h-full w-full object-cover object-center"
                />
                <span className="absolute left-1 top-1 whitespace-nowrap rounded bg-black/60 px-1.5 py-0.5 text-[10px] text-accent-300">
                  {u.badge}
                </span>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-semibold text-foreground-50">{u.title}</h3>
                <p className="mt-1 truncate text-xs text-foreground-300">{u.episode}</p>
                <p className="mt-1.5 text-[11px] text-primary-400">
                  <i className="ri-refresh-line mr-0.5" aria-hidden="true"></i>{u.timeLabel}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}